<div class="list-data quotation-list" [ngClass]="{'hidden': options?.length === 0}">
    <p-listbox emptyMessage=" "  [options]="options" [(ngModel)]="selectedValue" (onClick)="onQuotationSelection($event)">
        <ng-template let-data pTemplate="item">
            <div class="quotation-item w-full flex-body justify-content-between"
            [ngClass]="{'highlighted-item' : (hoveredQuotation === data.code)}">
            <span class="m-r-8">{{data | quotationDisplay}}
                <span class="default-text green" *ngIf = "data.isDefaultQuotation">{{'DEFAULT' | translate}}</span>
             </span>
                <a class="align-right more-info" (click)="openPdf(data)" pTooltip="{{'vbeiOpenQuotationInNewTab' | translate}}" tooltipPosition="top"><i class="ei ei-15 ei-new-tab"></i></a>
                <a class="align-right more-info" (mouseenter)="openToolTip($event,overlayReference,data)"><i
                    class="ei ei-16 ei-info"></i></a>
            </div>
        </ng-template>
    </p-listbox>
</div>
<label *ngIf="options && options.length === 0" class="no-data-msg">
    {{'vbeiNoQuotationAvailableError' | translate}}</label>
<label [ngClass]="{'hidden': (options && (options.length > 0 || options.length <= 0))}" class="no-data-msg loading-label">{{'vbeLoading' | translate}}</label>

<p-overlayPanel #overlayReference [showCloseIcon]="true" [appendTo]="'body'" [dismissable]="true"
    [styleClass]="'analyses-detail overflow-overlay'" [style]="{'width': '460px'}" [baseZIndex]="950000"
    (onHide)="onHide()" class="p-overlaypanel-arrow-left">
    <div>
        <div *ngIf="quotation">
            <div class="p-dynamic-dialog-body quotation-details">
                <div style="padding-bottom: 10px;">
                    <span class="quotation-name">{{quotation.quotationName}}</span>
                </div>
                <div>
                    <span class="quotation-version">{{quotation.quotationCode}}</span>
                </div>
                <div>
                    <ul class="quotable-items">
                        <li *ngFor="let r of quotation.items" class="quotable-item">
                            <span class="font-bold">[{{r.code}}]</span>&nbsp;{{r.name}}
                            <ul class="quotable-items">
                                <div *ngIf="r.testQuotationLines">
                                    <li *ngFor="let t of r.testQuotationLines" class="quotable-item">
                                        <span class="font-bold">[{{t.code}}]</span>&nbsp;{{t.name}}
                                    </li>
                                </div>
                                <div *ngIf="r.packageQuotationLines">
                                    <li *ngFor="let p of r.packageQuotationLines" class="quotable-item">
                                        <span class="font-bold">[{{p.packageCode}}]</span>&nbsp;{{p.packageName}}
                                        <ul *ngIf="p.tests" class="quotable-items">
                                            <li *ngFor="let tt of p.tests" class="quotable-item">
                                                <span class="font-bold">[{{tt.code}}]</span>&nbsp;{{tt.name}}
                                            </li>
                                        </ul>
                                    </li>
                                </div>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</p-overlayPanel>
